import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getCurrentUserID } from '../../../api/currentUserID.js';
import { canManageUsers } from '../server/access.js';

/** Drives the sidebar entry and the page gate. Answers `false` rather than throwing. */
export const mayIManageUsers = registerQuery({
  type: () => Boolean,
  operationName: 'mayIManageUsers',
  resolve: () => {
    return async () => {
      const userID = getCurrentUserID();
      if (!userID) return false;
      return canManageUsers(userID);
    };
  },
  params: [],
});
